export default __webpack_public_path__ + "static/media/3022546.0ae031e7.png";